module.exports = __webpack_public_path__ + "img/194.fixed_coffee_machine.aa544c48.svg";